<template>
  <div class="card-box_img">
    <img :height="height" :src="src" alt="" @click="openView(linkUrl)" />
  </div>
</template>
<script>
import { openView } from '@/utils';
export default {
  name: 'AsideCard',
  props: {
    height: String,
    src: String,
    linkUrl: String,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_URL,
    };
  },
  methods: {
    openView,
  },
};
</script>

<style lang="scss" scoped>
.card-box_img {
  margin-bottom: 10px;
  color: #fff;
  overflow: hidden;
  cursor: pointer;
  &:hover {
    img {
      transform: scale(1.2);
    }
  }
  img {
    width: 100%;
    transition: all 0.6s;
  }
}
</style>
